import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import SliderCard from 'components/home/SliderCard';
import styles from './SliderSpectacles.module.css';
import PharosAsideCard from "./PharosAsideCard"; // à créer pour les styles personnalisés

export default function SliderSpectacles({ allSpectacles = [] }) {
    if (!allSpectacles.length) return null;

    return (
        <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={5}
            slidesPerView={4}
            breakpoints={{
                300: { slidesPerView: 1 },
                600: { slidesPerView: 2 },
                902: { slidesPerView: 3 },
                1500: { slidesPerView: 4 },
            }}
            className={styles.swiper}
            aria-label="Carrousel des spectacles et concerts à venir"
        >
            {allSpectacles.map((spectacle) => (
                <SwiperSlide key={spectacle.id}>
                    <SliderCard
                        name={spectacle.name}
                        plage_date={spectacle.plage_date}
                        plage_date_part1={spectacle.plage_date_part1}
                        plage_date_part2={spectacle.plage_date_part2}
                        poster={spectacle.poster}
                        typeShow={spectacle.typeShow}
                        link={`/programme/${spectacle.typeShow?.code}/${spectacle.slug}`}
                    />
                </SwiperSlide>
            ))}
        </Swiper>

    );
}
